<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Breadcrumb>
                                        <BreadcrumbItem>{{$route.meta.title}}</BreadcrumbItem>
                                    </Breadcrumb>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button v-if="$store.state.userinfo.group_id === 1" type="primary" size="small" class="text-font-sm" @click="exportIncomeData"><Icon type="md-paper-plane" /> 导出项目收入</Button>
                                        <Button v-if="$store.state.userinfo.group_id === 1" type="error" size="small" class="text-font-sm" @click="exportExpendData"><Icon type="md-paper-plane" /> 导出项目支出</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                    </ButtonGroup>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="project_id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" fixed-shadow="hide" no-data-text="暂无数据记录">
                                <template #name="{ row }">
                                    <div @click="showData(row.project_id)" class="d-width text-primary cursor" :title="row.name">
                                        <span>{{row.name}}</span>
                                    </div>
                                </template>
                                <template #money="{ row }">
                                    <div class="d-width" :title="row.money">
                                        <strong class="text-violet">{{row.money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #collection_money="{ row }">
                                    <div @click="CollectionMoneyData(row.project_id)" class="d-width cursor" :title="row.collection_money">
                                        <strong class="text-success">{{row.collection_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #debt_money="{ row }">
                                    <div class="d-width" :title="row.debt_money">
                                        <strong class="text-danger">{{row.debt_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #expend_money="{ row }">
                                    <div @click="ExpendMoneyData(row.project_id)"  class="d-width cursor" :title="row.expend_money">
                                        <strong class="text-orange">{{row.expend_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #expense_money="{ row }">
                                    <div @click="ExpenseMoneyData(row.project_id)" class="d-width cursor" :title="row.expense_money">
                                        <strong class="text-violet">{{row.expense_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #balance_money="{ row }">
                                    <div class="d-width cursor" :title="row.balance_money">
                                        <strong :class="!!row.balance_money && row.balance_money >= 0?'text-success':'text-danger'">{{row.balance_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #invoice_money="{ row }">
                                    <div @click="InvoiceMoneyData(row.project_id)" class="d-width cursor" :title="row.invoice_money">
                                        <strong class="text-primary">{{row.invoice_money ?? '0.00'}}</strong>
                                    </div>
                                </template>
                                <template #company="{ row }">
                                    <div @click="customerData(row.customer_id)" class="d-width cursor" :title="row.company">
                                        <Poptip trigger="hover" title="联系方式" >
                                            <span>{{row.company}}</span>
                                            <template #content>
                                                <p>公司：{{row.company}}</p>
                                                <p>称呼：{{row.customer_real_name}}</p>
                                                <p>电话：{{row.customer_mobile}}</p>
                                                <p v-if="!!row.customer_wechat">微信：{{row.customer_wechat}}</p>
                                            </template>
                                        </Poptip>
                                    </div>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 8" color="blue" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 9" color="purple" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 11" color="purple" :text="row.status_name" />
                                    <Poptip v-else-if="row.status === 10" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                        <Badge color="red" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else color="#999999" :text="row.status_name" />
                                </template>
                                <template #action="{ row }">
                                    <a class="text-font-sm text-primary" @click="showData(row.project_id)">查看</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 详情  -->
                    <show-modal v-if="is_show" ref="ShowRef"></show-modal>

                    <!-- 客户详情 -->
                    <customer-show-modal v-if="is_customer" ref="CustomerRef"></customer-show-modal>

                    <!-- 项目回款 -->
                    <collection-money-modal v-if="is_collection_money" ref="CollectionMoneyRef"></collection-money-modal>

                    <!-- 项目材料支出 -->
                    <expend-money-modal v-if="is_expend_money" ref="ExpendMoneyRef"></expend-money-modal>

                    <!-- 项目报销支出 -->
                    <expense-money-modal v-if="is_expense_money" ref="ExpenseMoneyRef"></expense-money-modal>

                    <!-- 发票统计 -->
                    <invoice-money-modal v-if="is_invoice_money" ref="InvoiceMoneyRef"></invoice-money-modal>

                    <!--导出支出-->
                    <Modal
                        v-model="is_export_expend"
                        title="导出项目支出数据"
                        @on-ok="onExportExpend"
                        :loading="export_expend_loading"
                        width="800px"
                        ok-text="立即导出"
                        @on-cancel="cancelExportExpend">
                        <Row :gutter="32">
                            <Col :span="24">
                                <Form ref="SearchForms" :model="SearchForms" :rules="SearchRules"  label-position="left">
                                    <Row :gutter="32">
                                        <Col :span="12">
                                            <FormItem label="项目" prop="project_id" :rules="{required: true,type:'number' , message: '必填', trigger: 'change', transform(value) { return parseFloat(value)}}">
                                                <Select class="search-select"  v-model="SearchForms.project_id"  clearable filterable  placeholder="选择项目">
                                                    <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="采购" prop="buyer_id">
                                                <Select class="search-select" v-model="SearchForms.buyer_id"  clearable filterable  placeholder="选择采购">
                                                    <Option :value="item.buyer_id" v-for="(item,index) in buyerList" :key="index">{{item.title}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="支付类型" prop="type_id">
                                                <Select class="search-select"   v-model="SearchForms.type_id"  clearable filterable  placeholder="选择收入类型">
                                                    <Option :value="item.id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="申请人" prop="apply_id">
                                                <Select class="search-select"   v-model="SearchForms.apply_id"  clearable filterable  placeholder="选择申请人">
                                                    <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="状态" prop="status">
                                                <Select class="search-select"   v-model="SearchForms.status"  clearable filterable  placeholder="选择状态">
                                                    <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="申请日期" prop="time">
                                                <DatePicker class="width-100" v-model="SearchForms.time" clearable type="daterange" format="yyyy-MM-dd"  placeholder="选择日期" />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                    </Modal>

                    <!--导出收入-->
                    <Modal
                        v-model="is_export_income"
                        title="导出收入数据"
                        @on-ok="onExportIncome"
                        :loading="export_income_loading"
                        width="800px"
                        ok-text="立即导出"
                        @on-cancel="cancelExportIncome">
                        <Row :gutter="32">
                            <Col :span="24">
                                <Form ref="SearchIncomeForms" :model="SearchIncomeForms" :rules="SearchIncomeRules"  label-position="left">
                                    <Row :gutter="32">
                                        <Col :span="12">
                                            <FormItem label="项目" prop="project_id" :rules="{required: true,type:'number' , message: '必填', trigger: 'change', transform(value) { return parseFloat(value)}}">
                                                <Select class="search-select"  v-model="SearchIncomeForms.project_id"  clearable filterable  placeholder="选择项目">
                                                    <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="收入类型" prop="type_id">
                                                <Select class="search-select"   v-model="SearchIncomeForms.type_id"  clearable filterable  placeholder="选择收入类型">
                                                    <Option :value="item.id" v-for="(item,index) in incomeTypeList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="其他" prop="other_id">
                                                <Select class="search-select" v-model="SearchIncomeForms.other_id"  clearable filterable  placeholder="其他">
                                                    <Option :value="1">计划收款</Option>
                                                    <Option :value="2">非计划收款</Option>
                                                    <Option :value="3">需要发票</Option>
                                                    <Option :value="4">无需发票</Option>
                                                    <Option :value="5">待开发票</Option>
                                                    <Option :value="6">未全额开票</Option>
                                                    <Option :value="7">已开票</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="申请人" prop="apply_id">
                                                <Select class="search-select"   v-model="SearchIncomeForms.apply_id"  clearable filterable  placeholder="选择申请人">
                                                    <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="状态" prop="status">
                                                <Select class="search-select"   v-model="SearchIncomeForms.status"  clearable filterable  placeholder="选择状态">
                                                    <Option :value="item.id" v-for="(item,index) in incomeStatusList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="申请日期" prop="time">
                                                <DatePicker class="width-100" v-model="SearchIncomeForms.time" clearable type="daterange" format="yyyy-MM-dd"  placeholder="选择日期" />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                    </Modal>
                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import {exportExpend, exportIncome, getProjectConfig, getProjectList} from '@/apis/project'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import ShowModal from "../public/Show";
import CollectionMoneyModal from "../public/CollectionMoney";
import ExpendMoneyModal from "../public/ExpendMoney";
import ExpenseMoneyModal from "../public/ExpenseMoney";
import InvoiceMoneyModal from "../public/InvoiceMoney";
import CustomerShowModal from "../../customer/index/Show";
export default {
    name: "ProjectWork",
    components: {
        Headers, Side, ShowModal, CustomerShowModal, CollectionMoneyModal, ExpendMoneyModal, ExpenseMoneyModal, InvoiceMoneyModal
    },
    data () {
        return {
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    title: '项目名称',
                    key: 'name',
                    slot: 'name',
                    minWidth: 160,
                },
                {
                    title: '甲方',
                    key: 'company',
                    slot: 'company',
                    width: 240
                },
                {
                    title: '项目金额',
                    key: 'money',
                    slot: 'money',
                    width: 120
                },
                {
                    title: '项目回款',
                    key: 'collection_money',
                    slot: 'collection_money',
                    width: 120
                },
                {
                    title: '项目欠款',
                    key: 'debt_money',
                    slot: 'debt_money',
                    width: 120
                },
                {
                    title: '材料支出',
                    key: 'expend_money',
                    slot: 'expend_money',
                    width: 120
                },
                {
                    title: '报销支出',
                    key: 'expense_money',
                    slot: 'expense_money',
                    width: 120
                },
                {
                    title: '项目结余',
                    key: 'balance_money',
                    slot: 'balance_money',
                    width: 120
                },
                {
                    title: '开票金额',
                    key: 'invoice_money',
                    slot: 'invoice_money',
                    width: 120
                },
                {
                    title: '项目进度',
                    key: 'status',
                    slot : 'status',
                    width:120
                },
                {
                    title: '操作',
                    key: 'action',
                    slot : 'action',
                    align: 'center',
                    width : 85
                }
            ],
            is_show : false,
            is_customer : false,
            is_collection_money : false,
            is_expend_money : false,
            is_expense_money : false,
            is_invoice_money : false,


            is_export_income : false,
            export_income_loading : true,
            SearchIncomeForms: {
                project_id: '',
                type_id: '',
                other_id: '',
                apply_id: '',
                status: '',
                time: []
            },
            SearchIncomeRules: {},

            is_export_expend : false,
            export_expend_loading : true,
            SearchForms: {
                project_id: '',
                buyer_id: '',
                type_id: '',
                apply_id: '',
                status: '',
                time: []
            },
            SearchRules: {},
            projectList: [],
            buyerList: [],
            typeList: [],
            userList: [],
            statusList: [],

            customerList: [],
            incomeTypeList: [],
            incomeStatusList: [],

            site_url : this.$siteApi,



        }
    },
    created(){
        this.getList();
        this.getConfig();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        exportIncomeData(){
            let that = this;
            that.is_export_income =  true;
        },
        onExportIncome(){
            let that = this;
            that.export_income_loading = true;
            this.$refs['SearchIncomeForms'].validate((valid) => {
                if (valid) {
                    exportIncome({search:that.SearchIncomeForms}).then( e =>{
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                        if(e.data){
                            //下载文件
                            const fileUrl = that.site_url + e.data.url; // 文件的URL地址
                            const parts = fileUrl.split('/');
                            const fileName = parts[parts.length - 1];
                            const link = document.createElement('a');
                            link.href = fileUrl;
                            link.target = '_blank';
                            link.setAttribute('download', fileName);
                            link.click();
                        }else{
                            that.$Message.error({ background: true,duration:3, content: '没有文件可下载'});
                        }
                        that.cancelExportIncome();
                        that.export_income_loading = false;
                        setTimeout(function(){
                            that.export_income_loading = true;
                        },100)
                    })
                }else{
                    that.export_income_loading = false;
                    setTimeout(function(){
                        that.export_income_loading = true;
                    },100)
                }
            })

        },
        cancelExportIncome(){
            let that = this;
            that.is_export_income =  false;
            that.SearchIncomeForms = {
                project_id: '',
                type_id: '',
                other_id: '',
                apply_id: '',
                status: '',
                time: []
            }
        },
        exportExpendData(){
            let that = this;
            that.is_export_expend =  true;
        },
        onExportExpend(){
            let that = this;
            that.export_expend_loading = true;
            this.$refs['SearchForms'].validate((valid) => {
                if (valid) {
                    exportExpend({search:that.SearchForms}).then( e =>{
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                        if(e.data){
                            //下载文件
                            const fileUrl = that.site_url + e.data.url; // 文件的URL地址
                            const parts = fileUrl.split('/');
                            const fileName = parts[parts.length - 1];
                            const link = document.createElement('a');
                            link.href = fileUrl;
                            link.target = '_blank';
                            link.setAttribute('download', fileName);
                            link.click();
                        }else{
                            that.$Message.error({ background: true,duration:3, content: '没有文件可下载'});
                        }
                        that.cancelExportExpend();
                        that.export_expend_loading = false;
                        setTimeout(function(){
                            that.export_expend_loading = true;
                        },100)
                    })
                }else{
                    that.export_expend_loading = false;
                    setTimeout(function(){
                        that.export_expend_loading = true;
                    },100)
                }
            })

        },
        cancelExportExpend(){
            let that = this;
            that.is_export_expend =  false;
            that.SearchForms = {
                project_id: '',
                buyer_id: '',
                type_id: '',
                apply_id: '',
                status: '',
                time: []
            }
        },
        /**
         功能：
         time: 2025/12/20 16:24
         **/
        customerData(customer_id){
            let that = this;
            that.is_customer = true;
            setTimeout(function(){
                that.$refs.CustomerRef.show(customer_id);
            })
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        getConfig(){
            let that = this;
            getProjectConfig().then(e=>{
                that.projectList = e.data.projectList ?? [];
                that.buyerList = e.data.buyerList ?? [];
                that.typeList = e.data.expendTypeList ?? [];
                that.userList = e.data.userList ?? [];
                that.statusList = e.data.statusList ?? [];
                that.incomeTypeList = e.data.incomeTypeList ?? [];
                that.incomeStatusList = e.data.incomeStatusList ?? [];
            })
        },
        /**
         功能：
         time: 2025/12/20 10:39
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getProjectList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },
        /**
         功能：
         time: 2025/12/20 10:40
         **/
        showData(project_id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowRef.show(project_id);
            })
        },
        CollectionMoneyData(project_id){
            let that = this;
            that.is_collection_money = true;
            setTimeout(function(){
                that.$refs.CollectionMoneyRef.show(project_id);
            })
        },
        ExpendMoneyData(project_id){
            let that = this;
            that.is_expend_money = true;
            setTimeout(function(){
                that.$refs.ExpendMoneyRef.show(project_id);
            })
        },
        ExpenseMoneyData(project_id){
            let that = this;
            that.is_expense_money = true;
            setTimeout(function(){
                that.$refs.ExpenseMoneyRef.show(project_id);
            })
        },
        InvoiceMoneyData(project_id){
            let that = this;
            that.is_invoice_money = true;
            setTimeout(function(){
                that.$refs.InvoiceMoneyRef.show(project_id);
            })
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
